import React, { Fragment } from 'react';

import INST01 from './INST01';
import INST02 from './INST02';
import INST03 from './INST03';
import INST04 from './INST04';
import INST05 from './INST05';
import INST06 from './INST06';
import INST07 from './INST07';
import INST08 from './INST08';

import {
    Grid
} from '@material-ui/core';


const Instrument = ({ panel, instrument, message, event, alarm, device, schedules, commands, sendCommands }) => {

    return (
        <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="stretch">

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST01' === instrument.code) ? (
                    <INST01 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST01>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST02' === instrument.code) ? (
                    <INST02 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST02>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST03' === instrument.code) ? (
                    <INST03 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST03>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST04' === instrument.code) ? (
                    <INST04 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST04>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST05' === instrument.code) ? (
                    <INST05 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST05>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST06' === instrument.code) ? (
                    <INST06 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST06>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST07' === instrument.code) ? (
                    <INST07 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST07>) : <div></div>
                }

            </Grid>

            <Grid
                item
                ms={12}
                xs={12}>

                {('INST08' === instrument.code) ? (
                    <INST08 instrument={instrument}
                        message={message}
                        event={event}
                        instruments={panel.instruments}
                        device={device}
                        schedules={schedules}
                        commands={commands}
                        sendCommands={sendCommands}
                        alarm={alarm}>
                    </INST08>) : <div></div>
                }

            </Grid>
        </Grid>
    );
}

Instrument.propTypes = {
    className: Instrument.string
};

export default Instrument;